
import React from 'react';
import { MdInfoOutline } from "react-icons/md";

type Props = {
  text: string;
  containerClassName?: string;
  textClassName?: string;
  showIcon?: boolean;
  iconClassName?: string;
  containerStyle?: React.CSSProperties;
  onLinkClick?: (e: React.MouseEvent) => void;
  children?: React.ReactNode;
};

const Disclaimer: React.FC<Props> = ({
  text,
  children,
  containerClassName = "",
  textClassName = "",
  showIcon = true,
  iconClassName = "text-primary-lightgreen",
  containerStyle = {},
  onLinkClick,
}) => {
  return (
    <div
      id="disclaimer"
      className={`p-4 bg-white border border-primary-lightgreen rounded-lg flex flex-col gap-3 w-full ${containerClassName}`}
      style={containerStyle}
    >
      <div className="flex items-start gap-3">
        {showIcon && (
          <div id="disclaimer-icon-container" className="flex items-center pt-1">
            <MdInfoOutline size={20} className={iconClassName} />
          </div>
        )}

        <div onClick={onLinkClick} className="flex-1">
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className={`text-[#384248] font-normal text-base ${textClassName}`}
          />
          { children }
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
